import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../pages/nurse/Layout';

import NurseDashboard from '../pages/nurse/Dashboard';
import NurseSettings from '../pages/nurse/Settings';
import NurseCalendar from '../pages/nurse/Calendar';
import Sessions from '../pages/nurse/Sessions';
import Patients from '../pages/nurse/Patients';
import ADHACourse from '../pages/course/ADHDCourse';
import ComingSoon from '../components/ComingSoon';
import NotFound from '../components/NotFound';


const NurseRoutes = () => {
  // Debug once: check any undefined
  // console.log({ ADHACourse, Layout, NurseDashboard, NurseSettings, NurseCalendar, Sessions, ComingSoon });

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<NurseDashboard />} />
        <Route path="settings" element={<NurseSettings />} />
        <Route path="calendar" element={<NurseCalendar />} />
        <Route path="sessions" element={<Sessions />} />
        <Route path="patients" element={<Patients />} />
        <Route path="adhdcourse" element={<ADHACourse />} />

    
        <Route
          path="*"
          element={
            <NotFound/>
          }
        />
      </Routes>
    </Layout>
  );
};

export default NurseRoutes;
